import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const inputVariants = cva(
  "w-full rounded-lg border bg-white text-sm transition-[border-color,box-shadow] file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "h-12 rounded-card border-border bg-slate-50 px-3.5 text-slate-900 placeholder:text-slate-400 focus-visible:border-primary focus-visible:bg-white focus-visible:shadow-[0_0_0_4px_hsl(var(--primary)/0.12)]",
        form: "h-10 border-[#d1d5db] px-3 py-2.5 focus-visible:border-primary",
        search:
          "h-auto border-[1.5px] border-border px-3 py-2 focus-visible:border-primary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Input = React.forwardRef(({ className, type, variant, ...props }, ref) => (
  <input
    type={type}
    className={cn(inputVariants({ variant }), className)}
    ref={ref}
    {...props}
  />
));
Input.displayName = "Input";

export { Input, inputVariants };
